import * as d3 from "d3";
import _ from "lodash";
import store from '@/store/store';
import { EventBus } from '@/eventBus';
export default class {
    
    control = {
        crainData: null
    };

    constructor() {
        // Do nothing
    }

    async plotData(svgDiv, cmdata, clusters, neighbours, labels, recency, reset) {
        
        document.getElementById("load-div-heatmap").classList.add("show");
        //console.log(cmdata, clusters, neighbours, labels, reset);
        d3.select(svgDiv)
        
        let margin = {top: 100, right: 100, bottom: 100, left: 100};
        let width = document.getElementById(svgDiv.split(" ")[0].slice(1)).offsetWidth - margin.left - margin.right;
        let height = document.getElementById(svgDiv.split(" ")[0].slice(1)).offsetHeight - margin.top - margin.bottom;

        const svgExist = d3.select(svgDiv+" svg");
        
        if(reset){
            svgExist.remove();
        }
        
        const svg = d3.select(svgDiv)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .call(d3.zoom().on("zoom", function () {
                let transform = d3.event.transform;
                svg.attr("transform", d3.event.transform);
                d3.selectAll(".labels").style('font-size', 10-transform.k+'px');
             }))
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")")
              
        
        const colors = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff', '#000000']

        const xValue = d => d.x;
        const yValue = d => d.y;     
        
        // Add X axis
        const x = d3.scaleLinear()
            .domain(d3.extent(cmdata, xValue))
            .range([ 0, width ]);
        //svg.call(d3.axisBottom(x));

        // Add Y axis
        const y = d3.scaleLinear()
            .domain(d3.extent(cmdata, yValue))
            .range([ height, 0]);
        //svg.call(d3.axisLeft(y));

        let dotColors = d3.scaleOrdinal()
            .domain(Array.from({length: clusters}, (_, index) => index))
            .range(colors.slice(0, clusters))  
        
        let recencyColors = d3.scaleLinear()
            .domain([-3,0,3])
            .range(["grey","white","orange"])

        let plotSize = d3.scaleLinear().domain([_.minBy(cmdata, function(o) { return o.size; }).size, _.maxBy(cmdata, function(o) { return o.size; }).size]).range([5, 50]);
        
        // drop shadow filter
        let reposition = 1         // adjust to prevent clipping
        let scaleBoundingBox = 4   // adjust to prevent clipping
        let angle = 1.75 * Math.PI // angle of the offset, measured from the right, clockwise in radians
        let distance = 7           // how far the shadow is from object
        let blur = 2               // ammount of Gausian blur
        let shadowColor = '#003152'// 
        let shadowOpacity = .4     // how strong the shadow is
        
        var dropShadow = svg
        .append("filter")
            .attr("id", "dropshadow")
            .attr("x", (1-scaleBoundingBox)/2 + reposition * Math.cos(angle) )
            .attr("y", (1-scaleBoundingBox)/2 - reposition  * Math.sin(angle) )
            .attr("width",  scaleBoundingBox)
            .attr("height", scaleBoundingBox)
            .attr("filterUnits", "objectBoundingBox"); // userSpaceOnUse or objectBoundingBox
        dropShadow.append("feGaussianBlur")
            .attr("in", "SourceAlpha")
            .attr("stdDeviation", blur)
            .attr("result", "blur");
        dropShadow.append("feOffset")
            .attr("in", "blur")
            .attr("dx", distance *  Math.cos(angle) )
            .attr("dy", distance * -Math.sin(angle) )
            .attr("result", "offsetBlur")
        dropShadow.append("feFlood")
            .attr("in", "offsetBlur")
            .attr("flood-color", shadowColor)
            .attr("flood-opacity", shadowOpacity )
            .attr("result", "offsetColor");
        dropShadow.append("feComposite")
            .attr("in", "offsetColor")
            .attr("in2", "offsetBlur")
            .attr("operator", "in")
            .attr("result", "offsetBlur");
            
        var feMerge = dropShadow.append("feMerge");
        feMerge.append("feMergeNode")
            .attr("in", "offsetBlur")
        feMerge.append("feMergeNode")
            .attr("in", "SourceGraphic");
        
        if(recency){

            for (let i = 0; i < clusters; i++) {
                drawHex(cmdata.filter(q => { return q.cluster === i }), i)
            }

        }    
            // Add dots
        let groups = svg.append('g')
            .selectAll("dots")
            .data(cmdata)
            .enter()
            .append("g")
            .style("opacity", recency? "1":"0.6");
        
        groups.append("circle")
            .attr("cx", function (d) { return x(d.x); } )
            .attr("cy", function (d) { return y(d.y); } )
            .attr("r", function (d) { return (plotSize(d.size)); } )
            .style("fill", function(d){return recency? recencyColors(recencyNumber(d.recency)):dotColors(d.cluster) })
            .attr("stroke", "white")
            .attr("filter", "url(#dropshadow)");  // This is what applies the drop shadow to each object
            
        if(labels){
            groups.append("text")
                .attr("class", "labels")
                .attr("x", function (d) { return x(d.x) + ((plotSize(d.size)))+2; } )
                .attr("y", function (d) { return y(d.y) + ((plotSize(d.size)))/2; } )
                .text(function (d) { return d.label; })
                .style('font-size', '10px')
                .style('color', '#666666');
        }
        
            groups.on('mouseover', function(event, d) {
                    d3.select(this).style("opacity", "1");
                    d3.select(this).style("font-size", "12px"); 
                    d3.select(this).style("font-weight", "900"); 
                } )
                .on('mouseleave', function(event, d) { 
                    d3.select(this).style("opacity", recency? "1":"0.6")
                    d3.select(this).style("font-size", "10px"); 
                    d3.select(this).style("font-weight", "400"); 
                } )
                .on('click', function(d) {
                    EventBus.$emit('showOptions', [[d.item]]);
                    store.dispatch('saveSubsetFilter', [svgDiv, [d.item]])
                });
        
        /*if(!labels){
            svg.append('g')
                .selectAll("texts")
                .data(cmdata)
                .enter()
                .append("text")
                .attr("class", "labels")
                .attr("x", function (d) { return x(d.x) + ((plotSize(d.size)))+2; } )
                .attr("y", function (d) { return y(d.y) + ((plotSize(d.size)))/2; } )
                //.attr("id", function (d) { return "text"+d.n; })
                //.attr("x", 0)
                //.attr("y", function (d) { return d.n*10; } )
                .text(function (d) { return d.label; })
                .style('font-size', '10px')
                .style('color', '#666666');
            /*
            svg.append('g')
                .selectAll("cons")
                .data(cmdata)
                .enter()
                .append("line")
                .style("stroke", "grey")
                .style("stroke-width", 1)
                .attr("x1", function (d) { return d3.select('#text'+d.n).size(); })
                .attr("y1", function (d) { return d.n*10; })
                .attr("x2", function (d) { return x(d.x); })
                .attr("y2", function (d) { return y(d.y); });
            
        }*/
        /*
        let dots = svg.selectAll("circle");
            dots.on("mouseover", function(){
            var mouse = d3.mouse(this);
            d3.select(this)
                //.attr("fill", "#039BE5")
                .attr("stroke", "#000000")
                //.attr("stroke-width", "1px")
            d3.select("#hoverDiv")
                .style('top', mouse[0] + 10 + 'px')
                .style('left', mouse[1] + 10 + 'px')
                .html(`
                    <strong>Label here</strong>`)
                .style("opacity", 1);
            })

            dots.on("mouseout", function(){
            d3.select("#hoverDiv")
                .style("opacity", 0);
            })
        */
        function recencyNumber(r){
            if(r === 'inf'){
                return 3
            }
            else if(r === '-inf'){
                return -3
            }
            else{
                return r
            }    
        }
        function drawHex(data, c) {

            var densityData = d3.contourDensity()
            .y(function(d) { return y(d.y); })
            .x(function(d) { return x(d.x); })(data)

            //let contours = densityData(data);
  
            svg.append('g')
            .selectAll("path")
            .data(densityData)
            .enter()
            .append("path")
            .attr("d", d3.geoPath())
            .attr("fill", "none")
            //.style("opacity", "0.3")
            .attr("stroke", colors[c])
            .attr('stroke-width', 5)
            .attr("stroke-opacity", "0.1")
            .attr("stroke-linejoin", "round")

        }
        document.getElementById("load-div-heatmap").classList.remove("show");

    }
}